/* eslint-disable no-undef */

APP.HomePage = function () {
  new APP.AddonBar();
  new APP.BurgerMenu('#main-menu', '#nav li a');

  window.addEventListener('resize', this._setPromoPosition);
  setTimeout(this._setPromoPosition, 100);

  new APP.TabSwitch('#apps', '#platform-tabs li', '#apps .apps-content li', 'active');
};

APP.HomePage.prototype._setPromoPosition = function () {
  var promoImage = document.querySelector('.promo .promo-image');
  var promoTitle = document.querySelector('.promo .title');
  var promoSection = document.querySelector('.promo section');
  if (!promoImage || window.innerWidth < APP.conf.breakPoints.tablet2Min) {
    return;
  }
  if (!promoTitle || !promoSection) {
    return;
  }
  promoTitle.style.marginTop = (promoImage.offsetHeight - promoTitle.offsetHeight) / 2 + 'px';
  promoSection.style.left = (window.innerWidth - (window.promoSectionHeight || promoSection.offsetWidth)) / 2 + 'px';
  promoSection.style.visibility = 'visible';
};
